<template>
  <div class="toolbar">
    <div class="btn-group">
      <slot></slot>
      <a-button
        v-for="(item, index) of toolBarList"
        :key="index"
        @click="item.handle(item)"
        :type="item.type"
        :loading="item.loading && btnLoading.loading"
      >
        {{item.text}}
      </a-button>
    </div>
  </div>
</template>

<script>
// :disabled="item.authDisabled || item.disabled"
import toolBarAuth from '@/utils/mixins/toolBarAuth';
export default {
  mixins: [toolBarAuth],
  name: 'toolbar',
  props: {
    toolBarList: {
      type: Array,
      default: () => []
    },
    btnLoading: {
      default: () => ''
    }
  },
  data () {
    return {};
  }
};
</script>
